import { render, staticRenderFns } from "./BeneficiaryDetails.vue?vue&type=template&id=f48fb104&scoped=true"
import script from "./BeneficiaryDetails.vue?vue&type=script&lang=js"
export * from "./BeneficiaryDetails.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=f48fb104&prod&scoped=true&lang=css&external"
import style1 from "./BeneficiaryDetails.vue?vue&type=style&index=1&id=f48fb104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48fb104",
  null
  
)

export default component.exports